module.exports = {
    storage: {
        NODE_ENV: "prod",
        processedData: [],
        rawData: []
    }
};